import IconPin from "assets/img/icon-pin.svg?react"
import IconPinOutline from "assets/img/icon-pin-outline.svg?react"
import iconStatusWarning from "assets/img/icon-status-warning.svg"

import "./List.scss"

import { FC, useMemo, ReactNode } from "react"
import cx from "classnames"

import { Flex, FlexItem } from "components/Flex"

export enum ListItemType {
    horizontal = "horizontal",
    verticalSection = "vertical-section",
    vertical = "vertical"
}
export interface IListItem {
    label?: ReactNode
    value?: ReactNode
    subLabel?: ReactNode
    subValue?: ReactNode
    isInvalid?: boolean
    isInvalidHighlighted?: boolean
    isOverlined?: boolean
    labelTestId?: string
    valueTestId?: string
    type?: ListItemType
    toolbar?: ReactNode
    pinned?: boolean
    onPinnedToggle?: () => void
}

export interface IListProps {
    items?: IListItem[]
    labelWidth?: string
    maxWidthLabel?: string
    valueWidth?: string
    borderBetween?: boolean
    compact?: boolean
}

const List: FC<IListProps> = ({
    items,
    labelWidth,
    maxWidthLabel,
    valueWidth,
    borderBetween = true,
    compact,
}) => {
    const itemsToDisplay = useMemo<IListItem[]>(() => {
        return items?.filter(item => {
            return typeof item.label !== "undefined"
                || typeof item.value !== "undefined"
        }) || []
    }, [items])

    if (itemsToDisplay.length === 0) return null

    return (
        <div className={cx("list", {
            "list--border-between": borderBetween,
            "list--compact": compact,
        })}>
            {itemsToDisplay.map((item, idx) => (
                <div className={cx([
                    "list__item",
                    `list__item--type-${item.type || "horizontal"}`,
                    {
                        "border-top-black-bold": item.isOverlined,
                    },
                ])} key={idx}>
                    {!!item.onPinnedToggle &&
                        <button className="list__item-pin" onClick={item.onPinnedToggle}>
                            {item.pinned ? <IconPin /> : <IconPinOutline />}
                        </button>
                    }
                    {typeof item.label !== "undefined" &&
                        <div className="list__item-label" style={{ width: labelWidth, maxWidth: maxWidthLabel }}>
                            <Flex alignItems="center"
                                justifyContent="space-between"
                                gap="1.6rem">
                                <FlexItem>
                                    {item.label}
                                    {item.type !== 'vertical' && !!item.subLabel && <div className="list__item-subLabel">
                                        {item.subLabel}
                                    </div>}
                                </FlexItem>
                                {!!item.toolbar &&
                                    <FlexItem className="font-size-base font-regular">
                                        {item.toolbar}
                                    </FlexItem>
                                }
                            </Flex>
                        </div>
                    }
                    {typeof item.value !== "undefined" && item.value !== null && item.value !== "" &&
                        <Flex className="list__item-value" alignItems="center" style={{ width: valueWidth }}>
                            <FlexItem className={cx([
                                "list__item-value-content", {
                                    "list__item-value-content--with-error": item.isInvalid && item.isInvalidHighlighted,
                                }])}><div>
                                    {item.value}
                                    {
                                        item.type !== 'vertical' && !!item.subValue && <div className="list__item-value-subContent">
                                            {item.subValue}
                                        </div>
                                    }
                                </div>
                            </FlexItem>
                            {item.isInvalid &&
                                <FlexItem className="ml-2">
                                    <img src={iconStatusWarning} className="d-block" alt="" />
                                </FlexItem>
                            }
                        </Flex>
                    }

                </div>
            ))}
        </div>
    )
}

export default List
